export default {
  urlImage: 'http://39.107.228.160',
  uploadFlie: 'http://39.107.228.160',
  // uploadFlie: 'http://127.0.0.1:9999',
}



// WEBPACK FOOTER //
// ./src/axios/baseUrl.js